export default "__VITE_ASSET__CVi$Vqy7__"